import { t } from '@lingui/macro';
import { ErrorPage } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { useNavigate } from 'react-router-dom';
import { useBookingActions } from '../../pages/BookingFlow/bookingStore';

export const NewBookingErrorPage = () => {
  const { clearStore } = useBookingActions();
  const navigate = useNavigate();

  function cleanUpAndNavigateToNewBooking() {
    clearStore();
    navigate(customerRoutes.newBookingAddress.getPath());
  }

  return (
    <ErrorPage
      title={t`Something went wrong`}
      description={t`Something didn't go as planned while filling in your booking details. Please try again`}
      buttonProps={{
        onButtonClick: () => cleanUpAndNavigateToNewBooking(),
        buttonText: t`New booking`
      }}
      logInput={{
        value: 'New Booking Error Page',
        severity: 'error'
      }}
    />
  );
};
